import React, { useMemo, useState, useCallback } from "react";

import TableContainer from "../../Components/Common/TableContainer";
import { Col, Row, Card, CardBody } from "reactstrap";
import Spinners from "Components/Common/Spinner";
import Breadcrumbs from "../../Components/Common/Breadcrumb";
import DeleteModal from "../../Components/Common/DeleteModal";
import {
  useDeleteCustomer,
  useGetCustomerById,
  useGetCustomers,
} from "hooks/useCustomers";
import EditCustomerModal from "./EditCustomerModal";
import AddCustomerModal from "./AddCustomerModal";
import CellActions from "../../Components/CellActions"; // Import the CellActions component
import CustomerDetailModal from "./CustomerDetailModal";
import { RootState } from "slices";
import { useSelector } from "react-redux";

function Customers() {
  document.title = "Papermap | Customers"; // Change title for customers

  const selectedBranch = useSelector(
    (state: RootState) => state.branch?.currentBranch
  );

  const [showAddModal, setShowAddModal] = useState<boolean>(false);
  const [showEditModal, setShowEditModal] = useState<boolean>(false);
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [resource, setResource] = useState<any>(null);
  const [editDetails, setEditDetails] = useState<any>(null);

  const [selectedCustomerId, setSelectedCustomerId] = useState<string | null>(
    null
  );

  const { data, isLoading } = useGetCustomers(selectedBranch?.id);
  const { data: selectedCustomer } = useGetCustomerById(
    selectedCustomerId || ""
  );
  console.log(selectedCustomer);
  const { mutate: deleteCustomer } = useDeleteCustomer();

  const toggleAddModal = useCallback(
    () => setShowAddModal(!showAddModal),
    [showAddModal]
  );
  const toggleEditModal = useCallback(
    () => setShowEditModal(!showEditModal),
    [showEditModal]
  );

  const onClickDelete = (item: any) => {
    setResource(item);
    setDeleteModal(true);
  };

  const handleDeleteConfirm = async () => {
    if (resource) {
      deleteCustomer(resource.id);
      setDeleteModal(false);
      setResource(null);
    }
  };

  const columns = useMemo(
    () => [
      {
        header: "Customer ID",
        accessorKey: "id",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Name",
        accessorKey: "name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Email",
        accessorKey: "email", // Assuming customers have an email field
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Phone",
        accessorKey: "phone", // Assuming customers have a phone field
        enableColumnFilter: false,
        enableSorting: true,
      },
      // {
      //   header: "Status",
      //   accessorKey: "id",
      //   enableColumnFilter: false,
      //   enableSorting: true,
      //   cell: (cellProps: any) => (
      //     <Badge
      //       className={`font-size-12 badge-soft-${
      //         cellProps.row.original.status === "Active" ? "success" : "danger"
      //       }`}
      //     >
      //       {cellProps.row.original.status}
      //     </Badge>
      //   ),
      // },
      {
        header: "Tags",
        accessorKey: "tags",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Action",
        accessorKey: "action",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cellProps: any) => (
          <CellActions
            data={cellProps.row.original} // Pass the row data to the CellActions component
            onEdit={() => {
              setEditDetails(cellProps.row.original);
              toggleEditModal(); // Trigger edit modal
            }} // Define the onEdit action
            onView={() => {
              // setEditDetails(cellProps.row.original);
              const customerId = cellProps.row.original.id; // Get the customer ID
              setSelectedCustomerId(customerId); // Set the selected customer ID
              toggle(); // Trigger edit modal
            }} // Define the onEdit action
            onDelete={(data) => onClickDelete(data)} // Define the onDelete action
          />
        ),
      },
    ],
    [toggleEditModal]
  );
  const [viewModal, setViewModal] = useState(false);
  const toggle = () => {
    setViewModal(!viewModal);
  };
  console.log(data);

  return (
    <React.Fragment>
      <AddCustomerModal isOpen={showAddModal} toggle={toggleAddModal} />
      <EditCustomerModal
        isOpen={showEditModal}
        toggle={toggleEditModal}
        customer={editDetails}
      />
      <CustomerDetailModal
        data={selectedCustomer}
        isOpen={viewModal}
        toggle={toggle}
      />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteConfirm}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Customers" breadcrumbItem="View Customers" />
          {isLoading ? (
            <Spinners />
          ) : (
            <Row>
              <Col xs={12}>
                <Card>
                  <CardBody>
                    <TableContainer
                      columns={columns}
                      data={data || []}
                      isGlobalFilter={true}
                      isAddButton={true}
                      isCustomPageSize={true}
                      handleUserClick={toggleAddModal}
                      isPagination={true}
                      SearchPlaceholder="Search Customers..."
                      buttonClass="btn btn-success btn-rounded waves-effect waves-light mb-2 me-2 addCustomer-modal"
                      buttonName="Add New Customer"
                      tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline"
                      theadClass="table-light"
                      pagination="pagination"
                      paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}
        </div>
      </div>
    </React.Fragment>
  );
}

export default Customers;
